<template lang="pug">
  el-form#custom-content(
    :model="formAnswer"
    :rules="rules"
    ref="formAnswer")

    el-row(:gutter="20" style="margin: 2%;")
      el-col(:span="24" style="display: flex; flex-direction: row; justify-content: flex-start; flex-wrap: wrap;")
        div(style="flex-grow: 1;")
          el-badge(
            :value="badgeValue"
            :type="badgeType"
            :hidden="hideBadge"
            style="width: 400px;")
          el-row.margin-top-20(
              v-for="(option, index) in answerOptions"
              :gutter="30"
              :key="option"
            )
              el-col(
                :span="24"
                :style="index % 2 == 0 ? 'clear: left;' : ''"
              )
                el-checkbox(
                  v-model="formAnswer.answers"
                  :label="option"
                )
                  p.padding-right-20(v-html="option")

    // Buttons
    el-row(:gutter="20" style="margin: 2%;")
      el-col(:span="24" style="display: flex; flex-direction: row; justify-content: flex-start; flex-wrap: wrap; align-items: baseline;")
        el-button-group(style="margin: 30px 15px 0 0")
            el-button(
              icon="el-icon-error"
              :loading="processing"
              :disabled="finished"
              @click="clearForm")
                small Clear
            el-button(
              type="primary"
              icon="el-icon-document"
              :loading="processing"
              :disabled="finished || formAnswer.answers.length == 0"
              @click="onSubmitValidate('formAnswer')")
                small Submit

</template>

<script>
  import utilMixin from '@/components/mixins/utilMixin'
  import shuffleArray from 'helpers/shuffleArray'

  export default {
    name: 'SelectView',

    mixins: [utilMixin],

    props: {
      questionData: {
        type: Object,
        required: true,
      },
      isGraded: {
        type: Boolean,
        required: true,
      },
    },

    data() {
      return {
        hideBadge: true,
        badgeType: 'success',
        badgeValue: '✓',
        formAnswer: {
          answers: [],
        },
        rules: {
          answers: [
            { required: true, message: 'Please select at least one answer.', trigger: 'blur' },
          ],
        },
        processing: false,
        finished: false,
      }
    },

    computed: {
      answerOptions() {
        var options = this.questionData.correct.concat(this.questionData.others)
        return shuffleArray(options)
      },
    },

    watch: {
      questionData() {
        this.formAnswer.answers = []
        this.hideBadge = true
        this.processing = false
        this.finished = false
      },
    },

    mounted() {

    },  

    methods: {
      onSubmitValidate(formName) {
        this.hideBadge = true
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.processing = true
            this.axios.post('/api/quiz/' + this.$store.state.quizData.id + '/question/' + this.questionData.id + '/check', {
              answer: this.formAnswer.answers,
              isAnswered: this.questionData.isAnswered,
            })
              .then((result) => {
                this.$emit('questionSubmitted', {
                  id: this.questionData.id,
                  score: result.data.score,
                })
                this.hideBadge = false

                if (result.data.score >= this.questionData.score) {
                  this.badgeType = 'success'
                  this.badgeValue = '✔'
                } else {
                  this.badgeType = 'danger'
                  this.badgeValue = '✘'
                }
                this.processing = false
                this.finished = this.isGraded
              })
              .catch((error) => {
                this.processing = false
                this.mNotification( {error: error, message: 'There was an error checking your answer.'} )
              })
          } else {
            return false
          }
        })
      },

      clearForm() {
        this.formAnswer.answers = []
        this.hideBadge = true
      },

    },
  }
</script>

<style module>
  #sublabel {
    font-size: 12px;
    font-style: italic;
  }

  #subtext {
    font-size: 16px;
    margin-left: 5px;
  }

  #answer-box {
    font-size: 16px;
    padding: 8px 15px 8px 15px;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    background-color: #fff;
  }

</style>
